export { MEMO_PROGRAM_ADDRESS } from '@solana-program/memo';
export { TOKEN_2022_PROGRAM_ADDRESS } from '@solana-program/token-2022';

/** @internal */
export const SOLANA_PROTOCOL = 'solana:';

/** @internal */
export const HTTPS_PROTOCOL = 'https:';

/** @internal */
export const SOL_DECIMALS = 9;
